import * as actions from './actions';
import reducer from './reducer';
import selectors from './selectors';
import namespace from './types';

export {
    actions,
    selectors,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    [namespace]: reducer,
};
